export const validateRefdebtSchema = json => {
    return true;
};
